export default {
  interCode: {
    validator: function validator(value) {
      return (/^([0\+]\d{2,3})$/.test(value)
      );
    },
    message: "请输入正确的国际编号"
  },
  zoneCode: {
    validator: function validator(value) {
      return (/^(0\d{2,3})$/.test(value)
      );
    },
    message: "请输入正确的区号"
  },
  telephone: {
    validator: function validator(value) {
      return (/^(\d{7,8})(-(\d{1,}))?$/.test(value)
      );
    },
    message: "请输入正确的电话号码"
  },
  email: {
    validator: function validator(value, param) {
      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      var len = change2star(value).length;
      if (param && param.length > 0) {
        return len <= param[0] && /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);
      } else {
        return (/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value)
        );
      }
    },
    message: "请输入正确的邮箱地址",
    tipMessage: "emailTipMessage"
  },
  url: {
    validator: function validator(value) {
      return (/^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value)
      );
    },
    message: "请输入正确的路径"
  },
  ip: {
    validator: function validator(value) {
      return (/^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])|\*)\.((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])|\*)\.((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])|\*)\.((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])|\*)$/.exec(value)
      );
    },
    message: "请输入正确的IP"
  },
  eqValue: {
    validator: function validator(value, param) {
      return value == param;
    },
    message: "两次输入不一致"
  },
  length: {
    validator: function validator(value, param) {
      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      var len = change2star(value).length;
      return len >= param[0] && len <= param[1];
    },
    message: "请输入 {0} 到 {1}个字符，1个中文算2个字符",
    tipMessage: "输入 {0} 到 {1}个字符，1个中文算2个字符"
  },

  mobile: {
    validator: function validator(value) {
      return (/^([+]?[\d]{1,3}-|[ ])?((13[0-9]{9})|(18[0-9]{9})|(15[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(16[0-9]{9})|(19[0-9]{9}))$/.exec(value) || /^([5|6|9])\d{7}$/.exec(value) || /^[0][9]\d{8}$/.exec(value)
      );
    },
    message: "请输入正确的手机号码"
  },

  tel: {
    validator: function validator(value) {
      return (/^(([0\+]\d{2,3}-?)?(0\d{2,3})-?)?(\d{7,8})(-(\d{1,}))?$/.exec(value)
      );
    },
    message: "请输入正确的电话号码，格式为“+国际区号-区号-电话号码”"
  },

  mobileortel: {
    validator: function validator(value) {
      var mobileReg = /^([+]?[\d]{1,3}-|[ ])?((13[0-9]{9})|(18[0-9]{9})|(15[0-9]{9})|(14[0-9]{9})|(17[0-9]{9})|(16[0-9]{9})|(19[0-9]{9}))$/;
      var telReg = /^(([0\+]\d{2,3}-?)?(0\d{2,3})-?)?(\d{7,8})(-(\d{1,}))?$/;
      return mobileReg.test(value) || telReg.test(value);
    },
    message: "请输入正确的手机号码或者电话号码"
  },

  numchar: {
    validator: function validator(value, param) {
      function isnumchar(s) {
        var regularExpression = /^([\w])+$/;
        return regularExpression.test(s);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (param.length == 1) {
        this.message = "请输入{0}个字符,只能输入数字或英文字符";
      }

      if (isnumchar(value)) {
        var len = change2star(value).length;
        if (param.length == 1) {
          return len == param[0];
        } else {
          return len >= param[0] && len <= param[1];
        }
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,只能输入数字或英文字符"
  },

  numCharMinus: {
    validator: function validator(value, param) {
      function isNumcharMinus(s) {
        var regularExpression = /^([\w\-])+$/;
        return regularExpression.test(s);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (isNumcharMinus(value)) {
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,只能输入数字或英文字符或者'-'"
  },

  enChar: {
    validator: function validator(value, param) {
      function isEnglishChar(s) {
        var regularExpression = /[a-zA-Z]/;
        return regularExpression.test(s);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (isEnglishChar(value)) {
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,只能英文字符"
  },

  endDate: {
    validator: function validator(value, param, target) {
      var parForm = $($(target)[0].form);
      var beginDataVal = $("input[name=\"" + param + "\"]", parForm).val();
      var bgCombo = $("input[comboname=\"" + param + "\"]", parForm);
      if (bgCombo.data("datebox").options.separator) {
        beginDataVal = beginDataVal.replace(new RegExp("\\" + bgCombo.data("datebox").options.separator, "g"), "");
      }
      if ($(target).hasClass("kui-timespinner")) {
        value = $(target).timespinner("getValue");
      }
      if (!value) {
        if (bgCombo.length > 0) {
          var c = bgCombo.datebox("calendar");
          c.calendar("setMaxDate", "max");
        }
        return true;
      } else if (beginDataVal != "" && value < beginDataVal) {
        return false;
      } else {
        if (bgCombo.length > 0) {
          var _c = bgCombo.datebox("calendar");
          _c.calendar("setMaxDate", value);
        }
        return true;
      }
    },
    message: "截止日期不能小于起始日期"
  },
  begDate: {
    validator: function validator(value, param, target) {
      var parForm = $($(target)[0].form);
      var endDateVal = $("input[name=\"" + param + "\"]", parForm).val();
      var bgCombo = $("input[comboname=\"" + param + "\"]", parForm);
      if (bgCombo.data("datebox").options.separator) {
        endDateVal = endDateVal.replace(new RegExp("\\" + bgCombo.data("datebox").options.separator, "g"), "");
      }
      if (!value) {
        if (bgCombo.length > 0) {
          var c = bgCombo.datebox("calendar");
          c.calendar("setMinDate", "min");
        }
        return true;
      } else if (endDateVal != "" && value > endDateVal) {
        return false;
      } else {
        if (bgCombo.length > 0) {
          var _c2 = bgCombo.datebox("calendar");
          _c2.calendar("setMinDate", value);
        }
        return true;
      }
    },
    message: "起始日期不能大于截止日期"
  },
  begTime: {
    validator: function validator(value, param, target) {
      var parForm = $($(target)[0].form);
      var opts = $("input[spinnername=\"" + param[0] + "\"]", parForm).timespinner("options");
      var endTimeVal = $("input[spinnername=\"" + param[0] + "\"]", parForm).timespinner("getValue");
      if (opts.suffixStr) {
        endTimeVal = endTimeVal.slice(0, endTimeVal.length - 2);
      }
      endTimeVal = endTimeVal.replace(/:/g, "");
      var begTimeVal = value.replace(/:/g, "");
      if (!endTimeVal) {
        return true;
      } else if (endTimeVal != "" && begTimeVal > endTimeVal) {
        return false;
      } else {
        return true;
      }
    },
    message: "起始时间不能晚于截止时间！"
  },
  endTime: {
    validator: function validator(value, param, target) {
      var parForm = $($(target)[0].form);
      var opts = $("input[spinnername=\"" + param[0] + "\"]", parForm).timespinner("options");
      var begTimeVal = $("input[spinnername=\"" + param[0] + "\"]", parForm).timespinner("getValue");
      if (opts.suffixStr) {
        begTimeVal = begTimeVal.slice(0, begTimeVal.length - 2);
      }
      begTimeVal = begTimeVal.replace(/:/g, "");
      var endTimeVal = value.replace(/:/g, "");
      if (!begTimeVal) {
        return true;
      } else if (begTimeVal != "" && endTimeVal < begTimeVal) {
        return false;
      } else {
        return true;
      }
    },
    message: "截止时间不能早于起始时间！"
  },
  begNum: {
    validator: function validator(value, param, target) {
      var parForm = $($(target)[0].form);
      var endVal = $("input[numberboxname=\"" + param[0] + "\"]", parForm).numberbox("getValue");
      if (!endVal) {
        return true;
      } else if (endVal != "" && parseFloat(value) > parseFloat(endVal)) {
        return false;
      } else {
        return true;
      }
    },
    message: "起始值不能大于结束值！"
  },
  endNum: {
    validator: function validator(value, param, target) {
      var parForm = $($(target)[0].form);
      var begVal = $("input[numberboxname=\"" + param[0] + "\"]", parForm).numberbox("getValue");
      if (!begVal) {
        return true;
      } else if (begVal != "" && parseFloat(value) < parseFloat(begVal)) {
        return false;
      } else {
        return true;
      }
    },
    message: "结束值不能小于起始值！"
  },

  valFirst: {
    validator: function validator(value, param) {
      function checkfirstval(t) {
        return (/(^[\u4e00-\u9fa5a-zA-Z]+)([^\n]*)$/.test(value)
        );
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkfirstval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,且必须输入以字符开头"
  },

  val: {
    validator: function validator(value, param) {
      function keepchar(v, k) {
        $.each(k, function (index, val) {
          v = v.replace(k[index], " ");
        });
        return v;
      }

      function checkunval(t) {
        var regularExpression = /^[^@。，,？?【】《》<>：；\[\]{}!！+=—~|\/\'\\\"#$%&\^\*]+$/;
        return regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      var opts = $.data(arguments[2], "validatebox").options;
      var itemValue = opts.speTxt !== null ? keepchar(value, opts.speTxt) : value;

      if (checkunval(itemValue)) {
        var len = change2star(itemValue).length;
        !param[1] && (param = [1, param[0]]);
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,且不能输入特殊字符(中文算两个字符)"
  },

  address: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression = /^[^@。，,？?【】《》<>：；\[\]{}!！+=~|\/\'\\\"$%&\^\*]+$/;
        return regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = itemValue.length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,且不能输入除（‘#’、‘-’、‘.’、‘（）’）以外的特殊字符"
  },

  en_ch: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression = /[^\u4e00-\u9fa5a-zA-Z\-\_\.]+/;
        return !regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,只能输入中文或英文且不能输入特殊字符"
  },

  number: {
    validator: function validator(val, param) {
      var value = $.trim(val);

      function isnumber(s, p1, p2) {
        var regularExpression = "/^(-)?(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$/";
        return eval(regularExpression).test(s);
      }

      function isnumber2(s, p1) {
        var regularExpression = "/^(-)?(\\d){1," + parseInt(p1) + "}$/";
        return eval(regularExpression).test(s);
      }

      if (param && 1 === param.length) {
        this.message = "请输入正确的数字, 整数位最多{0}位";
      } else if (param && 2 === param.length) {
        this.message = "请输入正确的数字, 整数位最多{0}位, 小数位最多{1}位";
      }

      var flag = value.indexOf(".") != -1 ? isnumber(value, param[0], param[1]) : isnumber2(value, param[0]);
      if (!flag) {
        return false;
      } else if (value.indexOf(".") == value.length - 1) {
        return false;
      } else {
        return true;
      }
    },
    message: "请输入正确的数字"
  },

  numberex: {
    validator: function validator(val, param) {
      function getMessage(param) {
        if (2 === param.length) {
          return "0" == param[0] ? "请输入正确的整数，最多{1}位" : "10" == param[0] ? "请输入大于等于0的整数，最多{1}位" : "-10" == param[0] ? "请输入小于等于0的整数，最多{1}位" : "1" == param[0] ? "请输入正确的正整数，最多{1}位" : "-1" == param[0] ? "请输入正确的负整数，最多{1}位" : "2" == param[0] ? "请输入大于0且小于1的数字" : "请输入正确的数字";
        } else if (3 === param.length) {
          return "0" == param[0] ? "请输入正确的数字，小数点前最多{1}位，小数点后最多{2}位" : "10" == param[0] ? "请输入大于等于0的数字，小数点前最多{1}位，小数点后最多{2}位" : "-10" == param[0] ? "请输入小于等于0的数字，小数点前最多{1}位，小数点后最多{2}位" : "1" == param[0] ? "请输入大于0的数字，小数点前最多{1}位，小数点后最多{2}位" : "-1" == param[0] ? "请输入小于0的数字，小数点前最多{1}位，小数点后最多{2}位" : "2" == param[0] ? "请输入大于等于0且小于1的数字，小数点前最多{1}位，小数点后最多{2}位" : "3" == param[0] ? "请输入大于0且小于等于1的数字，小数点前最多{1}位，小数点后最多{2}位" : "4" == param[0] ? "请输入大于0且小于1的数字，小数点前最多{1}位，小数点后最多{2}位" : "5" == param[0] ? "请输入大于等于0且小于等于1的数字，小数点前最多{1}位，小数点后最多{2}位" : "请输入正确的数字";
        }

        return "请输入正确的数字";
      }
      this.message = getMessage(param);
      var value = $.trim(val);

      function isnumber(s, p0, p1, p2) {
        if (p0 == "0" || !p0) {
          var regularExpression = "^(-)?(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
              regularExpression2 = "^(-)?(\\d){1," + parseFloat(p1) + "}$";
          return new RegExp(regularExpression).test(s) || new RegExp(regularExpression2).test(s);
        } else if (p0 == "10") {
          var _regularExpression = "^(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
              _regularExpression2 = "^(\\d){1," + parseFloat(p1) + "}$";
          return new RegExp(_regularExpression).test(s) || new RegExp(_regularExpression2).test(s);
        } else if (p0 == "-10") {
          var _regularExpression3 = "^(-)(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
              _regularExpression4 = "^(-)(\\d){1," + parseFloat(p1) + "}$";
          return new RegExp(_regularExpression3).test(s) || new RegExp(_regularExpression4).test(s);
        } else if (p0 == "1") {
          var _regularExpression5 = "^(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
              _regularExpression6 = "^(\\d){1," + parseFloat(p1) + "}$";
          return (new RegExp(_regularExpression5).test(s) || new RegExp(_regularExpression6).test(s)) && Number(s) > 0;
        } else if (p0 == "-1") {
          var _regularExpression7 = "^(-)(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){1," + parseFloat(p2) + "}$",
              _regularExpression8 = "^(-)(\\d){1," + parseFloat(p1) + "}$";
          return (new RegExp(_regularExpression7).test(s) || new RegExp(_regularExpression8).test(s)) && Number(s) < 0;
        } else if (p0 == "2") {
          if (value < 1 && value >= 0) {
            var _regularExpression9 = "^(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$";
            return new RegExp(_regularExpression9).test(s);
          } else {
            return false;
          }
        } else if (p0 == "3") {
          if (value <= 1 && value > 0) {
            var _regularExpression10 = "^(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$",
                _regularExpression11 = "^(\\d){1," + parseFloat(p1) + "}$";
            return (new RegExp(_regularExpression10).test(s) || new RegExp(_regularExpression11).test(s)) && Number(s) > 0;
          } else {
            return false;
          }
        } else if (p0 == "4") {
          if (value < 1 && value > 0) {
            var _regularExpression12 = "^(\\d){1," + parseFloat(p1) + "}(\\.)(\\d){0," + parseFloat(p2) + "}$";
            return new RegExp(_regularExpression12).test(s);
          } else {
            return false;
          }
        } else if (p0 == "5") {
          if (value <= 1 && value >= 0) {
            var _regularExpression13 = "^(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$";
            return new RegExp(_regularExpression13).test(s);
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      function isnumber2(s, p0, p1) {
        if (p0 == "0" || !p0) {
          var regularExpression = "/^(-)?(\\d){1," + parseInt(p1) + "}$/";
          return eval(regularExpression).test(s);
        } else if (p0 == "10") {
          var _regularExpression14 = "/^(\\d){1," + parseInt(p1) + "}$/";
          return eval(_regularExpression14).test(s);
        } else if (p0 == "-10") {
          var _regularExpression15 = "/(^0$)|(^(-)(\\d){1," + parseInt(p1) + "}$)/";
          return eval(_regularExpression15).test(s);
        } else if (p0 == "1") {
          var _regularExpression16 = "/^[1-9](\\d){0," + (parseInt(p1) - 1) + "}$/";
          return eval(_regularExpression16).test(s);
        } else if (p0 == "-1") {
          var _regularExpression17 = "/^(-)[1-9](\\d){1," + (parseInt(p1) - 1) + "}$/";
          return eval(_regularExpression17).test(s);
        } else if (p0 == "2") {
          if (value < 1 && value >= 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      }

      if (!/^(\+|-)?(\d+)(,\d{3})*(\.\d+)?$/.test(value)) {
        return false;
      } else {
        if (value.indexOf(",") > 0) value = value.replace(/,/g, "");
      }

      var flag = param.length > 2 ? isnumber(value, param[0], param[1], param[2] || 0) : isnumber2(value, param[0], param[1]);

      if (!flag) {
        return false;
      } else if (value.indexOf(".") == value.length - 1) {
        return false;
      } else {
        return true;
      }
    },
    message: "请输入正确的数字"
  },

  money: {
    validator: function validator(val, param) {
      var value = $.trim(val);

      function isnumber(s, p1, p2) {
        if (s && s.length == 1 && s == 0) return true;
        var regularExpression = "/^(-)?(\\d){1," + parseFloat(p1) + "}(\\.)?(\\d){0," + parseFloat(p2) + "}$/";
        return eval(regularExpression).test(s);
      }

      function isnumber2(s, p1) {
        if (s && s.length == 1 && s == 0) return true;
        var regularExpression = "/^(-)?[1-9](\\d){0," + (parseInt(p1) - 1) + "}$/";
        return eval(regularExpression).test(s);
      }

      var flag = value.indexOf(".") != -1 ? isnumber(value, param[0], param[1]) : isnumber2(value, param[0]);
      if (!flag) {
        return false;
      } else if (value.indexOf(".") == value.length - 1) {
        return false;
      } else {
        return true;
      }
    },
    message: "请输入正确的金额"
  },

  "int": {
    validator: function validator(value, param) {
      if (value.indexOf(",") > 0) value = value.replace(/,/g, "");

      function isint(s) {
        var regularExpression = /^(-)?\d*$/;

        return regularExpression.test(s);
      }

      if (isint(value)) {
        var len = value.length;
        if (len > param[0]) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    message: "请输入正确的整数,最大{0}位"
  },

  zint: {
    validator: function validator(value, param) {
      if (value.indexOf(",") > 0) value = value.replace(/,/g, "");

      function iszint(s) {
        var regularExpression = /^[1-9]\d*$/;
        return regularExpression.test(s);
      }

      if (iszint(value)) {
        var len = value.length;
        if (len > param[0]) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    message: "请输入正确的正整数,最大{0}位"
  },

  intex: {
    validator: function validator(value, param) {
      function iszint(s, p1) {
        if (p1 == "10") {
          var regularExpression = /^[0-9]\d*$/;
          return regularExpression.test(s);
        } else if (p1 == "-10") {
          var _regularExpression18 = /^(-)[0-9]\d*$/;
          return _regularExpression18.test(s);
        } else if (p1 == "1") {
          var _regularExpression19 = /^[1-9]\d*$/;
          return _regularExpression19.test(s);
        } else if (p1 == "-1") {
          var _regularExpression20 = /^(-)[1-9]\d*$/;
          return _regularExpression20.test(s);
        } else {
          return false;
        }
      }
      if (!/^(\+|-)?(\d+)(,\d{3})*(\.\d+)?$/.test(value)) {
        return false;
      } else {
        if (value.indexOf(",") > 0) value = value.replace(/,/g, "");
      }

      if (iszint(value, param[1])) {
        var len = value.length;
        if (len > param[0]) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    message: "请输入正确的整数"
  },

  num: {
    validator: function validator(val, param) {
      var value = $.trim(val);

      function isnum(s, data) {
        var regularExpression = "/^(\\d){" + parseFloat(data) + "}$/";
        return eval(regularExpression).test(s);
      }

      function isnum1(s, data) {
        var regularExpression = "/^(\\d){" + parseFloat(param[0]) + "," + parseFloat(param[1]) + "}$/";
        return eval(regularExpression).test(s);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }
      if (param.length == 1) {
        if (isnum(value, param[0])) {
          var itemValue = change2star(value);
          if (itemValue.length >= param[0]) {
            return true;
          } else {
            this.message = "请输入{0}位数字";
            return false;
          }
        } else {
          this.message = "请输入{0}位数字";
          return false;
        }
      } else {
        var _itemValue = change2star(value);
        if (isnum1(value, param[0])) {
          if (_itemValue.length >= param[0] && _itemValue.length <= param[1]) {
            return true;
          } else {
            this.message = "请输入{0} 到 {1}位数字";
            return false;
          }
        } else {
          this.message = "请输入{0} 到 {1}位数字";
          return false;
        }
      }
    },
    message: "请输入{0} 到 {1}位数字"
  },

  unhan: {
    validator: function validator(val, param) {
      var value = $.trim(val);

      function isunhan(s) {
        var regularExpression = /[\x00-\xff]/;
        return regularExpression.test(s);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (isunhan(value) && change2star(value).length <= parseFloat(param)) {
        return true;
      } else {
        return false;
      }
    },
    message: "请输入{0}个字符(1个中文算2个字符),且不能以汉字开头!"
  },

  date: {
    validator: function validator(val) {
      var value = $.trim(val);

      function isdate(dayString) {
        var digit = "0123456789";
        var datelist = new Array(31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
        if (dayString.length != 8) {
          return false;
        }
        if (dayString == "00000000") {
          return true;
        }
        for (var i = 0; i < 8; i++) {
          if (digit.indexOf(dayString.charAt(i), 0) == -1) {
            return false;
          }
        }
        var year = dayString.substr(0, 4);
        var month = dayString.substr(4, 2);
        var date = dayString.substr(6, 2);
        if (year > 3000 || year < 1900 || month > 12 || month < 1 || date > 31 || date < 1) {
          return false;
        }
        if (date > datelist[month - 1]) {
          return false;
        }

        var yyyy = eval(year);
        if (month == "02") {
          if (yyyy % 400 == 0) {
            if (date > 29) {
              return false;
            }
          } else if (yyyy % 4 == 0 && yyyy % 100 != 0) {
            if (date > 29) {
              return false;
            }
          } else {
            if (date > 28) {
              return false;
            }
          }
        }
        return true;
      }

      if (isdate(value)) {
        return true;
      } else {
        return false;
      }
    },
    message: "请输入正确的日期",
    tipMessage: "20100101"
  },

  time: {
    validator: function validator(val) {
      var value = $.trim(val);

      function istime(timeString) {
        var regularExpression = /^(((([0-1][0-9])|(2[0-3])):(([0-5][0-9])):(([0-5][0-9])))|((([0-1][0-2])|[0-9]):(([0-5][0-9])):(([0-5][0-9]))\s[ap]m))$/;
        return regularExpression.test(timeString);
      }

      if (istime(value)) {
        return true;
      } else {
        return false;
      }
    },
    message: "请输入正确的时间"
  },

  postcode: {
    validator: function validator(val) {
      var value = $.trim(val);

      function ispostcode(s) {
        var patrn = /^[0-9]\d{3,7}$/;
        if (!patrn.exec(s)) {
          return false;
        }
        return true;
      }

      if (ispostcode(value)) {
        return true;
      } else {
        return false;
      }
    },
    message: "请输入正确的邮政编码"
  },

  cardno: {
    validator: function validator(val, isLen18) {
      var value = $.trim(val);

      this.message = isLen18 && isLen18[0] ? "请输入正确的18位身份证号" : "请输入正确的15或18位身份证号";

      function iscardno(s) {
        var area = {
          11: "北京",
          12: "天津",
          13: "河北",
          14: "山西",
          15: "内蒙古",
          21: "辽宁",
          22: "吉林",
          23: "黑龙江",
          31: "上海",
          32: "江苏",
          33: "浙江",
          34: "安徽",
          35: "福建",
          36: "江西",
          37: "山东",
          41: "河南",
          42: "湖北",
          43: "湖南",
          44: "广东",
          45: "广西",
          46: "海南",
          50: "重庆",
          51: "四川",
          52: "贵州",
          53: "云南",
          54: "西藏",
          61: "陕西",
          62: "甘肃",
          63: "青海",
          64: "宁夏",
          65: "新疆",
          71: "台湾",
          81: "香港",
          82: "澳门",
          91: "国外"
        };
        var idcard = s,
            Y = void 0,
            JYM = void 0;
        var SS = void 0,
            M = void 0,
            ereg = void 0;
        var idcard_array = new Array();
        idcard_array = idcard.split("");

        if (area[parseInt(idcard.substr(0, 2))] == null) {
          return false;
        }

        switch (idcard.length) {
          case 15:
            if (isLen18 && isLen18[0]) {
              return false;
            }
            if ((parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0 || (parseInt(idcard.substr(6, 2)) + 1900) % 100 == 0 && (parseInt(idcard.substr(6, 2)) + 1900) % 4 == 0) {
              ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}$/;
            } else {
              ereg = /^[1-9][0-9]{5}[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}$/;
            }
            if (ereg.test(idcard)) {
              return true;
            } else {
              return false;
            }
            break;
          case 18:
            if (parseInt(idcard.substr(6, 4)) % 4 == 0 || parseInt(idcard.substr(6, 4)) % 100 == 0 && parseInt(idcard.substr(6, 4)) % 4 == 0) {
              ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}[0-9Xx]$/;
            } else {
              ereg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|1[0-9]|2[0-8]))[0-9]{3}[0-9Xx]$/;
            }

            if (ereg.test(idcard)) {
              SS = (parseInt(idcard_array[0]) + parseInt(idcard_array[10])) * 7 + (parseInt(idcard_array[1]) + parseInt(idcard_array[11])) * 9 + (parseInt(idcard_array[2]) + parseInt(idcard_array[12])) * 10 + (parseInt(idcard_array[3]) + parseInt(idcard_array[13])) * 5 + (parseInt(idcard_array[4]) + parseInt(idcard_array[14])) * 8 + (parseInt(idcard_array[5]) + parseInt(idcard_array[15])) * 4 + (parseInt(idcard_array[6]) + parseInt(idcard_array[16])) * 2 + parseInt(idcard_array[7]) * 1 + parseInt(idcard_array[8]) * 6 + parseInt(idcard_array[9]) * 3;
              Y = SS % 11;
              M = "F";
              JYM = "10X98765432";
              M = JYM.substr(Y, 1);
              if (M == idcard_array[17]) {
                return true;
              } else {
                return false;
              }
            } else {
              return false;
            }
            break;
          default:
            return false;
            break;
        }
      }

      if (iscardno(value)) {
        return true;
      } else {
        return false;
      }
    },
    message: "请输入正确的身份证号"
  },

  orgcode: {
    validator: function validator(value) {
      var regularExpression = /^[1-9]\d*$/;
      if (regularExpression.test(value) && value < 32767) {
        return true;
      }
      return false;
    },
    message: ""
  },

  remote: {
    validator: function validator(params, opts) {
      var data = {};
      data[opts[1]] = params;
      var response = $.ajax({
        url: opts[0],
        dataType: "json",
        data: data,
        async: false,
        cache: false,
        type: "post"
      }).responseText;
      return response == "true";
    },
    message: "Please fix this field."
  },
  equalTo: {
    validator: function validator(value, param) {
      return $(param[0]).val() == value;
    },
    message: "字段不匹配"
  },
  normalchar: {
    validator: function validator(value, param) {
      return !/[\'\"]/.test(value);
    },
    message: "输入字符中包含非法字符"
  },

  ch_en_num: {
    validator: function validator(value, param) {

      function checkunval(t) {
        var regularExpression = /[^\u4e00-\u9fa5a-zA-Z\d]+/;
        return !regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,只能输入中文、英文和数字且不能输入特殊字符"
  },
  cnchar: {
    validator: function validator(value) {
      return (/^[\u4e00-\u9fa5]+$/.test(value)
      );
    },
    message: "只能输入中文字符"
  },
  name: {
    validator: function validator(value) {
      return (/^((([\u4e00-\u9fa5a-zA-Z\-\_\.\s])+)·?)+$/.test(value)
      );
    },
    message: "请输入正确的姓名"
  },
  u_time_valid: {
    validator: function validator(value) {
      if (!/^BEG:\d{2}:\d{2}:\d{2},END:\d{2}:\d{2}:\d{2}$/.test(value)) {
        return false;
      }
      var beg = value.substr(4, 8),
          begArr = beg.split(":"),
          end = value.substr(17, 8),
          endArr = end.split(":");
      if (begArr[0] > 24 || begArr[1] > 59 || begArr[2] > 59 || endArr[0] > 24 || endArr[1] > 59 || endArr[2] > 59 || beg > end) {
        return false;
      }
      return true;
    },
    message: "起止时间格式不正确（时间格式：BEG:00:00:00,END:23:59:59）"
  },
  cnname: {
    validator: function validator(value) {
      return (/^[\u4e00-\u9fa5]+(·[\u4e00-\u9fa5]+){0,3}[\u4e00-\u9fa5]$/.test(value)
      );
    },
    message: "请输入正确的中文姓名"
  },

  ch_en_num_syms: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\s\*]+$/;
        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,不能输入负数、小数、乱码（*）、空格"
  },

  ch_en_num_sym: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*]+$/;
        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,不能输入负数、小数、乱码（*）"
  },

  ch_num_sym: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*A-Za-z]+$/;
        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,不能输入负数、小数、英文、乱码（*）"
  },

  en_num_sym: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*\u4e00-\u9fa5]+$/;

        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,不能输入负数、小数、中文、乱码（*）"
  },

  num_sym: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*A-Za-z\u4e00-\u9fa5]+$/;
        var regularExpression2 = /^((-\d+)|(-\d+\.\d+)|(\d+\.\d+)?)?$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,不能输入负数、小数、中文、英文、乱码（*）"
  },

  numex_ch_sym: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression1 = /^[^\*A-Za-z]+$/;
        var regularExpression2 = /^(-[0-9\.{0,1}]+)$/;
        return regularExpression1.test(t) && !regularExpression2.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,不能输入负数、英文、乱码（*）"
  },

  val_sym: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression = /^[^\*]+$/;
        return regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,不能输入乱码（*）"
  },

  en_num_addr: {
    validator: function validator(value, param) {
      function checkunval(t) {
        var regularExpression = /^.*[^\d].*$/;
        return regularExpression.test(t);
      }

      function change2star(s) {
        return s.replace(/[^\x00-\xff]/g, "**");
      }

      if (checkunval(value)) {
        var itemValue = change2star(value);
        var len = change2star(value).length;
        return len >= param[0] && len <= param[1];
      } else {
        return false;
      }
    },
    message: "请输入 {0} 到 {1}个字符,不能全部输入数字字符"
  },

  compareBegAndCurrDate: {
    validator: function validator(value, current) {
      return current >= value;
    },
    message: "开始日期不能大于当天"
  },

  compareEndAndCurrDate: {
    validator: function validator(value, current) {
      return value >= current;
    },
    message: "结束日期不能小于当天"
  },

  en_name_addr: {
    validator: function validator(value) {
      return (/^[0-9a-zA-Z,()-\.\s'"]+$/.test(value)
      );
    },

    message: "请输入正确的字符，只能包含英文字母，逗号，句号，单引号，双引号。"

  },
  "en_name": {
    validator: function validator(value) {
      return (/^[0-9a-zA-Z,()-\.\s"\/]+$/.test(value)
      );
    },
    message: "请输入正确的字符，只能包含英文字母，逗号，句号，括号，短横线，双引号，斜杠。"
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui/default/validatebox/src/validate.js
// module id = 1476
// module chunks = 2